import React from "react";
import { useLang, SUPPORTED_LANGS } from "@/lib/i18n";
import { Languages } from "lucide-react";

export default function LanguageToggle({ compact = false }) {
  const { lang, setLang } = useLang();
  return (
    <div
      className={`inline-flex items-center gap-1 rounded-md border border-[#1E293B] bg-[#050A14] p-0.5 ${compact ? "" : "w-full"}`}
      data-testid="language-toggle"
      role="group"
      aria-label="Language"
    >
      {!compact && (
        <Languages className="w-3.5 h-3.5 text-[#94A3B8] mx-1.5" />
      )}
      {SUPPORTED_LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLang(l.code)}
          data-testid={`lang-${l.code}`}
          className={`flex-1 font-mono text-[10px] tracking-widest py-1 px-2 rounded transition-colors ${
            lang === l.code
              ? "bg-[#007AFF]/15 text-[#F8FAFC] border border-[#007AFF]/40"
              : "text-[#94A3B8] border border-transparent hover:text-[#F8FAFC]"
          }`}
          title={l.label}
        >
          {l.short}
        </button>
      ))}
    </div>
  );
}
